<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3 9.2 10.9M17 3l-5 14-2.8-6.1L3 8.1z"/></svg>
</template>
